import React from "react";
import { Button } from "./ui/button";

const Step1 = ({ onYes, onNo }) => {
  return (
    <div className="step-container step1">
      <div className="step1-content">
        <h1 className="step1-title">Ready to cum right now?</h1>
        <div className="step1-buttons">
          <Button
            onClick={onYes}
            className="btn-yes"
            size="lg"
          >
            YES, LET ME IN →
          </Button>
          <Button
            onClick={onNo}
            variant="outline"
            className="btn-no"
            size="lg"
          >
            No thanks
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Step1;
